import cx from "classnames";
import PropTypes from "prop-types";
import { useState } from "react";

const ReadMore = ({
  short,
  full,
  hideLink = false,
  linkClasses,
  alternativeAction,
  ...rest
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpanded = (e) => {
    e.preventDefault();

    if (alternativeAction) {
      alternativeAction(e);
    } else {
      setIsExpanded((currentIsExpanded) => !currentIsExpanded);
    }
  };

  const classes = cx({ "db mt2": isExpanded }, linkClasses || "link blue");

  return (
    <div {...rest}>
      {isExpanded ? full : short}
      {!hideLink && (
        <a className={classes} href="" onClick={toggleExpanded}>
          {isExpanded ? "Read\u00a0less" : " Read\u00a0more"}
        </a>
      )}
    </div>
  );
};

ReadMore.propTypes = {
  full: PropTypes.node.isRequired,
  short: PropTypes.node.isRequired,
  alternativeAction: PropTypes.func,
  hideLink: PropTypes.bool,
  linkClasses: PropTypes.string,
};

export default ReadMore;
